export const VELOCITY_LOCAL_STORAGE_KEY = 'velocity';

/**
 * The key used to store the user's favorite items in the local storage.
 */
export const FAVORITES_LOCAL_STORAGE_KEY = 'favorites';

export const LOYALTY_LOCAL_STORAGE_KEY = 'loyalty';

export const MERGED_CART_LOCAL_STORAGE_KEY = 'dismissedMergedCartBanners';

export const AUTOSHIP_SAVING_LOCAL_STORAGE_KEY = 'autoshipSavingCartBanner';

export const PROCEED_TO_CHECKOUT_PRESSED = 'proceedToCheckoutPressed';

export const WAS_LOGGED_USER_ADDRESS_CHANGED = 'wasLoggedUserAddressChanged';
